import React, { Component } from 'react';
import Button from 'shared/lib/components/Button';
import TextInput from 'shared/lib/components/TextInput';
import axios from 'axios';
import get from 'lodash/get';
import { CardElement } from '@stripe/react-stripe-js';

import './UpdatePaymentMethod.css';

export default class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardName: '',
      isCardComplete: false,
      isSubmitting: false,
      error: null,
    };
  }

  handleFieldChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = async event => {
    event.preventDefault();

    const { stripe, elements, linkToken, onSuccess } = this.props;

    if (!stripe || !elements) {
      return;
    }

    this.setState({ error: null, isSubmitting: true });

    const cardElement = elements.getElement(CardElement);

    stripe
      .createToken(cardElement, {
        name: this.state.cardName,
        address_country: 'US',
      })
      .then(({ token }) => {
        return axios.post('/api/user/v2/policies/update-billing', {
          link_token: linkToken,
          stripe_token: token.id,
        });
      })
      .then(() => {
        this.setState({ isSubmitting: false });
        onSuccess();
      })
      .catch(error => {
        this.setState({
          isSubmitting: false,
          error:
            get(error, 'response.data.error.message') || get(error, 'message'),
        });
      });
  };

  render() {
    const { cardName, stripe } = this.props;
    const { error, isSubmitting } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        {error && <div className="UpdatePaymentMethod-error">{error}</div>}
        <TextInput
          name="cardName"
          id="cardName"
          className="UpdatePaymentMethod-nameInput"
          required
          type="text"
          placeholder="Name on card"
          onChange={this.handleFieldChange}
          value={cardName}
        />
        <div className="UpdatePaymentMethod-cardWrapper">
          <CardElement
            options={{
              style: {
                base: {
                  fontSize: '16px',
                  color: '#00345c',
                  '::placeholder': {
                    color: '#aab7c4',
                  },
                },
                invalid: {
                  color: '#9e2146',
                },
              },
            }}
          />
        </div>
        <Button type="submit" disabled={!stripe || isSubmitting}>
          Submit
        </Button>
      </form>
    );
  }
}
